import { requestFactory, fetch } from './index';
const request = requestFactory('/api/dashboard');
export function getDropDownTeamUsers() {
    return request({
        method: 'get',
        url: '/auditlog/dropDownTeamUsers',
    });
}
export function getAuditlogList(data) {
    return request({
        method: 'post',
        url: '/auditlog/list',
        data,
    });
}
export function exportExcel(fileName, data) {
    const elink = document.createElement('a');
    elink.download = `${fileName}`;
    elink.style.display = 'none';
    elink.href = window.URL.createObjectURL(new Blob([data]));
    document.body.appendChild(elink);
    elink.click();
    window.URL.revokeObjectURL(elink.href);
    document.body.removeChild(elink);
}
export const exportAuditlogList = (data) => {
    return fetch({
        method: 'post',
        url: '/api/dashboard/auditlog/export',
        responseType: 'blob',
        data,
    }).then((res) => {
        if (res.status === 200) {
            exportExcel(res.headers?.['content-disposition']?.split('=')?.[1] || 'auditlog', res.data);
        }
        return res;
    });
};
